import {
	SOFTWARE_PROJECT,
	toProjectType,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import {
	type ApplicationEditions,
	STANDARD_EDITION,
} from '@atlassian/jira-shared-types/src/edition.tsx';

export const isProjectTypeAndEditionSupported = (
	applicationEditions: ApplicationEditions,
	project?: string,
): Boolean => {
	const projectType = toProjectType(project);

	if (!projectType || projectType !== SOFTWARE_PROJECT) {
		return false;
	}

	return applicationEditions.software === STANDARD_EDITION;
};

/**
 * Returns wether or not the current day of a given trial is
 * during the supported date range for this experiment
 */
export const isStartOfTrial = (daysLeft: number): boolean => daysLeft >= 8 && daysLeft <= 13;

export const getEpMessageId = (daysLeft: number): string | null => {
	if (daysLeft >= 11 && daysLeft <= 13) {
		return 'prj-end-of-trial-extension-message-1';
	}

	if (daysLeft >= 8 && daysLeft <= 10) {
		return 'prj-end-of-trial-extension-message-2';
	}

	return null;
};
